import { Box, useTheme } from "@mui/material"

type SalesPage = {
  src: string,
  title: string,
}

const SalesPage = (props: SalesPage) => {
  const { src, title } = props
  const theme = useTheme()

  return (
    <Box sx={{ color: theme.palette.color50555b.main }} className="m-16">
      <Box className="iframe-page-header">
        { title }
      </Box>
      <iframe
        style={{ width: '100%', height: '100vh', border: 'none' }}
        data-testid="med-device-sales-iframe"
        src={src}
      />
    </Box>
  )
}

export default SalesPage
